export default __webpack_public_path__ + "static/media/about1_1.db23a489.png";